var map = {
	"./1-prehistoire-light.svg": "abf5",
	"./1-prehistoire.svg": "fcde",
	"./2-explorations-light.svg": "5593",
	"./2-explorations.svg": "4810",
	"./3-francais-light.svg": "671e",
	"./3-francais.svg": "b7ae",
	"./4-britannique-light.svg": "c9fa",
	"./4-britannique.svg": "d30e",
	"./5-confederation-light.svg": "1ffe",
	"./5-confederation.svg": "3745",
	"./menu/logo.svg": "7b0f",
	"./menu/menu-icon.svg": "9488",
	"./menu/menu-retour.svg": "ec32",
	"./menu/x-menu.svg": "96f0",
	"./navigate.svg": "b51b",
	"./navigate_before-24px.svg": "869b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";